import { auth } from '../utils/firebase.js';
import { create } from "zustand";
import { _getGroupMembers } from "../data/groupMembers";

export const useCurrentGroupMembersStore = create((set, get) => ({
    groupId: "",
    groupMembers: {},
    isLoading: false,
    lastFetched: null,
    // 10 minutes in milliseconds

    clear: () => set({
        groupId: "",
        groupMembers: {},
        isLoading: false,
        lastFetched: null,
    }),

    setGroupId: (groupId) => set({
        groupId: groupId
    }),

    setGroupMembers: (groupMembers) => set((state) => ({
        groupMembers: {
            ...state.groupMembers,
            members: groupMembers
        }
    })),

    setGroupAdmins: (groupAdmins) => set((state) => ({
        groupMembers: {
            ...state.groupMembers,
            admins: groupAdmins
        }
    })),

    fetchGroupMembers: async (fetchGroupId, force = false) => {
        const { groupId, groupMembers, isLoading, lastFetched, cacheExpiration } = get();

        if (isLoading) return groupMembers;

        const isCacheExpired = !lastFetched || Date.now() - lastFetched > cacheExpiration;

        if (fetchGroupId === groupId && !force && !isCacheExpired) return groupMembers;

        try {
            set({ isLoading: true });
            var fetchedGroupMembers = await _getGroupMembers(fetchGroupId);
            set({
                groupMembers: fetchedGroupMembers,
                groupId: fetchGroupId,
                lastFetched: Date.now(),
                isLoading: false
            });

            return fetchedGroupMembers;
        } catch (error) {
            set({ isLoading: false });

            throw error;
        }
    },

    updateMemberOnSnapshot: async (memberGroupId, memberId, member, changeType) => {
        const { groupId, groupMembers, setGroupMembers } = get();

        if (memberGroupId !== groupId) return;
        let members = { ...groupMembers.members };
        const currentUser = auth.currentUser.uid;
        member.isMe = member.uid === currentUser;
        member.hasLogin = !!member.uid;

        switch (changeType) {
            case 'modified':
                members[memberId] = member;
                break;
            case 'removed':
                delete members[memberId];
                break;
            case 'added':
                members[memberId] = member;
                break;
        }

        set((state) => ({
            groupMembers: {
                ...state.groupMembers,
                members: members
            }
        }));
    },

    getMembers: () => {
        const { groupMembers } = get();
        return groupMembers?.members || [];
    },

    getAdmins: () => {
        const { groupMembers } = get();
        return groupMembers.admins || [];
    }

}));